/**
 * The message of a caught error, when it is an Error — else undefined.
 *
 * The idiom across the app is `err?.message || String(err)`: with strict
 * useUnknownInCatchVariables, a `catch (err)` binds `err` as unknown, so reading
 * `.message` off it no longer type-checks. errorMessage(err) restores exactly that
 * access — Error.message or undefined — so `errorMessage(err) || String(err)`
 * behaves identically while staying type-safe.
 */
export function errorMessage(err: unknown): string | undefined {
  return err instanceof Error ? err.message : undefined;
}
